const $window = $(window);
let updatedSpacing = false;
let resizeTimeout;
const targetNode = document.getElementById('PageContainer');
const config = { attributes: false, childList: true, subtree: true };

const callback = function(mutationsList, observer) {
	for(const mutation of mutationsList) {
		if (mutation.type === 'childList') {
			if ($window.innerWidth() < 768) {
				const $headerNotice = $('#qab_container');

				if ($headerNotice.length > 0 && updatedSpacing === false) {
					updateHeaderSpacingWithNoticeBar();

					updatedSpacing = true;
				} else if (updatedSpacing === true) {
					updateHeaderSpacingWithNoticeBar();

					updatedSpacing = false;
				}
			}
		}
	}
};

const observer = new MutationObserver(callback);

observer.observe(targetNode, config);

const updateHeaderSpacingWithNoticeBar = () => {
	const templateIsProduct = $('.template-product').length;
	if (templateIsProduct) {
		const headerHeight = $('.js-header').outerHeight();
		const $mainContent = $('.main-content');
		const $tags = $('.tags');
		let spacing = headerHeight;
		let mainContentSpacingTop = headerHeight + $tags.outerHeight();

		$mainContent.css('margin-top', mainContentSpacingTop);

		$tags.css('top', spacing);
	}
}

$(window).on('resize', function() {
	if (resizeTimeout) clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(function(){
		if ($window.innerWidth() < 768) {
			updateHeaderSpacingWithNoticeBar();
		}
	}, 100);
});


function watchProductSlider() {
	const $targets = $('.product-single__photo--flex-wrapper');
	const config = { 
		attributes: true, 
		attributeOldValue: true,
		childList: false, 
		subtree: false, 
		attributeFilter: [ "class" ] 
	};

	const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
      const $target = $(mutation.target);
    	const $imageWrapper = $target.find('.product-single__photo-wrapper');
  		const $zoomImages = $imageWrapper.find('.zoomImg');

  		// console.log(mutation.oldValue.includes('slick-active'),$target.hasClass('slick-active'));

  		if (!mutation.oldValue.includes('slick-active')) {
	  		if (!deviceIsTablet()) {
	  			$imageWrapper.zoom({magnify: 2});
	  		}
  		}
  		else {
  			$imageWrapper.find('.zoomImg').first().remove();
  		}
    }
	};

	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback);

	$targets.each(function(index, el) {
		observer.observe(el, config);
	});


	$('.product-single__photo-wrapper').first().find('img').on('load', function(event) {
		if (!deviceIsTablet()) {
			$(this).parent().zoom({magnify: 2});
		}
	});
}

$(window).on('load', function(event) {
	if (!deviceIsTablet()) {
		$('.product-single__photo-wrapper').first().zoom({magnify: 2});
	}
});

if ($('.product-single__photo--flex-wrapper').length) {
	const setter = setInterval(() => {
		if ($('.product-single__photo--flex-wrapper.slick-active .zoomImg').length) {
			clearInterval(setter)
		}
		else {
			if (!deviceIsTablet()) {
				$('.product-single__photo--flex-wrapper.slick-active .product-single__photo-wrapper').zoom({magnify: 2});
			}
		}
	},500)
}

watchProductSlider();

function changeImgSrc() {
	$('.js-var-img').on('mouseover', function() {
		const $this = $(this);
		const thisSrc = $this.attr('src');
		const newSrc = thisSrc.replace('x80', '400x');
		const newImg = $this.closest('.js-product-inner').find('.js-new-image');
		newImg.attr('src', newSrc);
		newImg.css('opacity', '1');
	});
}

$(document).on('mouseover', '.js-var-img-alt', function() {
	const $this = $(this);
	const thisSrc = $this.attr('src');
	
	const newImg = $this.closest('.js-product-inner').find('.js-new-image');
	newImg.attr('src', thisSrc);
	newImg.css('opacity', '1');
});

function changeImgSrcAlt() {
	$('.js-var-img-alt').on('mouseover', function() {
		const $this = $(this);
		const thisSrc = $this.attr('src');
		
		const newImg = $this.closest('.js-product-inner').find('.js-new-image');
		newImg.attr('src', thisSrc);
		newImg.css('opacity', '1');
	});
}



$(window).on('load scroll', function() {
	changeImgSrc();

	changeImgSrcAlt();
});

$(document).on('click', '.boost-pfs-filter-button', function() {
	$('.boost-pfs-filter-top-sorting').removeClass('boost-pfs-filter-sort-active');
	$('.boost-pfs-filter-filter-dropdown').css('display', 'none');
});

/**
 * Hero slider
 */

const $heroSlider = $('.js-hero-slider');

/**
 * Initialize hero slider
 * 
 * @return {Void}
 */
const initHeroSlider = ($heroSlider = $('.js-hero-slider')) => {
	if ($heroSlider.length != 0) {
		let config = {
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: true,
			prevArrow: $heroSlider.parent().find('.slider__prev'),
			nextArrow: $heroSlider.parent().find('.slider__next'),
			infinite: false,
			fade: true,
		};

		if ($heroSlider.data().autoloop === true) {
			config.autoplay = $heroSlider.data().autoloop;
			config.autoplaySpeed = $heroSlider.data().looptime;
		}

		if($heroSlider.children().length > 1) {
			$heroSlider.slick(config);
		}
	}
}

$heroSlider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
  $heroSlider.parent().find('.js-curent-slide').html(`${nextSlide + 1}`);
});

initHeroSlider();

$(window).on('shopify:section:load resize', (event) => {
	initHeroSlider();
});

/**
 * Products Slider
 */

const $productsSlider = $('.js-products-slider');

/**
 * Intialize products slider 
 * 
 * @return {Void} 
 */

const initProductsSlider = ($productsSlider = $('.js-products-slider')) => {
	if ($productsSlider.length != 0) {
		const config = {
			slidesToShow: 4,
			slidesToScroll: 4,
			dots: true,
			appendDots: $productsSlider.parent().find('.slider__nav'),
			arrows: true,
			prevArrow: $productsSlider.parent().find('.slider__prev'),
			nextArrow: $productsSlider.parent().find('.slider__next'),
			infinite: false,
			responsive: [
				{
					breakpoint: '1024',
					settings: {
						arrows: false,
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: '768',
					settings: {
						arrows: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		}

		$productsSlider
			.not('.slick-initialized')
			.slick(config);
	}
}

initProductsSlider();

$(window).on('shopify:section:load resize', (event) => {
	initProductsSlider();
});

/**
 * Collections slider
 */

$collectionsSlider = $('.js-slider-collections');

/**
 * Handle collections slider 
 * 
 * @return {Void} 
 */

const handleCollectionsSlider = ($collectionsSlider = $('.js-slider-collections')) => {
	if ($collectionsSlider.length != 0 && deviceIsTablet()) {
		$collectionsSlider.each((index, slider) => {
			const config = {
				dots: true,
				appendDots: $(slider).parent().find('.slider__nav'),
				arrows: false,
				infinite: false,
				slidesToShow: 2,
				slidesToScroll: 2,
				responsive: [
					{
						breakpoint: '768',
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			}

			$(slider)
				.not('.slick-initialized')
				.slick(config);
		});
	} else if($collectionsSlider.length != 0) {
		$collectionsSlider.each((index, slider) => {
			if($(slider).hasClass('slick-initialized')) {
				$(slider).unslick();
			}
		});
	} 
}

/**
 * Handle slider on shopify section render
 *
 * @param {Event} evt 
 * @return {Void}                                    
 */
$(window).on('shopify:section:load, load', (evt) => {
	handleCollectionsSlider();
});


/**
 * Init sliders on resize      
 *
 * @param {Event} evt 
 * @return {Void}                      
 */
$(window).on('resize', (evt) => {
	evt.preventDefault();

	handleCollectionsSlider();
});

/**
 * Size check
 */

const TABLET_WIDTH = 1024;
const MOBILE_WIDTH = 768;

/**
 * Check if user is on tablet
 * 
 * @return {Boolean}
 */
const deviceIsTablet = () => $(window).outerWidth() <= TABLET_WIDTH;

/**
 * Check if user is on mobile
 * 
 * @return {Boolean}
 */
const deviceIsMobile = () => $(window).outerWidth() <= MOBILE_WIDTH;


/**
 * Articles slider
 */

$articlesSlider = $('.js-articles-slider');

/**
 * Handle articles slider 
 * 
 * @return {Void} 
 */

const handleArticlesSlider = ($articlesSlider = $('.js-articles-slider')) => {
	if ($articlesSlider.length != 0 && deviceIsMobile()) {
		const config = {
			dots: true,
			appendDots: $articlesSlider.parent().find('.slider__nav'),
			arrows: false,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1
		}

		$articlesSlider
			.not('.slick-initialized')
			.slick(config);

	} else if($articlesSlider.length != 0) {
		if($articlesSlider.hasClass('slick-initialized')) {
			$articlesSlider.unslick();
		}
	} 
}

/**
 * Handle slider on shopify section render
 *
 * @param {Event} evt 
 * @return {Void}                                    
 */
$(window).on('shopify:section:load, load', (evt) => {
	handleArticlesSlider();
});


/**
 * Handle sliders on resize      
 *
 * @param {Event} evt 
 * @return {Void}                      
 */
$(window).on('resize', (evt) => {
	evt.preventDefault();

	handleArticlesSlider();
});

/**
 * Mobile navigation
 */

$('.js-nav-trigger').on('click', function(evt) {
	evt.preventDefault();
	$(this)
		.parent()
			.toggleClass('is-expanded')
	$('.js-header')
		.toggleClass('is-active');
});

$('.js-nav-dropdown > a .js-nav-dropdown-trigger').on('click', function(evt) {
	if (deviceIsTablet()) {
		evt.preventDefault();
		$(this)
			.parentsUntil('.nav__dropdown')
			.last()
			.parent()
			.toggleClass('is-expanded')
				.find('.js-mega-menu')
				.slideToggle();
	}
});

$(window).on('resize', (evt) => {
	evt.preventDefault();
	
	if (!deviceIsTablet()) {
		$('.js-mega-menu').removeAttr('style');
		$('.js-header').removeClass('is-active');
		$('.js-nav').removeClass('is-expanded');
	}
});
